export * from './map-details-tool.component';
